// Add protocols if neccesary
export function normalizeUri(uri) {
  const parser = document.createElement('a');
  parser.href = uri;

  return parser.pathname === `/${uri}` ? `http://${uri}` : uri;
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/utils/uri.js